import { Models } from '../../..';
import { ChampionshipsEndpoints } from '../../../endpoint';

export type ResponseChampionshipsNavigation = Models.ChampionshipsNavigation;

export interface ChampionshipsNavigationParams {
  mainContentId: Models.OppositionId;
  championshipId?: Models.ChampionshipId;
}

export type GetChampionshipsNavigation = (
  params: ChampionshipsNavigationParams,
) => Promise<ResponseChampionshipsNavigation>;

const getChampionshipsNavigation: GetChampionshipsNavigation = async params =>
  ChampionshipsEndpoints.getChampionshipsNavigation(params).then(response => response);

export { getChampionshipsNavigation };
